import { Environment } from './environment.model';
import { apiCommon } from './environment.common';

/**
 * Fallback compilé (ng serve --configuration test).
 * En runtime, /assets/config.json reste la source de vérité.
 */
export const environment: Environment = {
  production: false,
  mode: 'Test',
  keycloak: {
    url: '',
    realm: 'saar-test',
    clientId: 'mysaar',
    ssoUrl: '/realms/saar-test/protocol/openid-connect/token',
  },
  api: {
    ...apiCommon,
    uriSuffixe: '/test',
    urlBase: '',
    wsBaseUrl: 'wss',
  },
  enableApiLogs: true,
};
